var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselStatsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8917_8136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 26.25V0H0V26.25C0 27.2446 0.395088 28.1984 1.09835 28.9017C1.80161 29.6049 2.75544 30 3.75 30H30V26.25H3.75Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25 11.25H22.5V22.5H26.25V11.25Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 11.25H7.5V22.5H11.25V11.25Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 5H15V22.5H18.75V5Z",
    fill: "#29ABE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8917_8136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselStatsIcon);
export default __webpack_public_path__ + "static/media/carousel-stats-icon.a2f8c9571497272c02dbc0f161b9253d.svg";
export { ForwardRef as ReactComponent };